module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/electrical-panel/texturePanel.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/electrical-panel/texturePanel.png
// module id = 559
// module chunks = 0